module.exports = __webpack_public_path__ + "static/media/HomeGraphic8.c0c5da82.jpg";